import { SortDirection } from "@/api/shared";
import { useGetAffiliates } from "@/queries";
import {
  Box,
  CircularProgress,
  LinearProgress,
  Typography,
  useTheme,
} from "@mui/material";
import { FC } from "react";

const TopAffiliates: FC = () => {
  const theme = useTheme();

  const { affiliates, isAffiliatesLoading, affiliatesError } = useGetAffiliates(
    {
      page: 1,
      perPage: 10,
      sortBy: "earnings",
      sortDirection: SortDirection.DESC,
    }
  );
  const maxEarnings = affiliates?.[0]?.earnings || 1;

  if (isAffiliatesLoading) {
    return <CircularProgress />;
  }
  if (!affiliates || affiliatesError) {
    return null;
  }

  return (
    <Box borderRadius={2} width="100%">
      <Box display="flex" justifyContent="space-between" mb={2}>
        <Typography variant="subtitle1" fontWeight={600}>
          Top 10 affiliates
        </Typography>
        <Typography variant="body2">Earnings</Typography>
      </Box>

      {affiliates.map((affiliate, index) => {
        const percent = (affiliate.earnings / maxEarnings) * 100;

        return (
          <Box key={index} mb={2}>
            <Box display="flex" justifyContent="space-between" mb={0.5}>
              <Typography variant="body2">{`${
                affiliate.fullName
              } (${percent.toFixed(0)}%)`}</Typography>
              <Typography variant="body2">
                ${affiliate.earnings / 100}
              </Typography>
            </Box>
            <LinearProgress
              variant="determinate"
              value={percent}
              sx={{
                height: 6,
                borderRadius: 5,
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                "& .MuiLinearProgress-bar": {
                  backgroundColor: theme.palette.secondary.main,
                },
              }}
            />
          </Box>
        );
      })}
    </Box>
  );
};

export { TopAffiliates };
